import { common } from '../styles';

export default {
  wrapper: {
    ...common,
    height: '74px',
    p: '16px',
    boxShadow: '0px 1px 2px 0px #1018280D',
  },
};
